/**
 * DisplayItem > Cta object.
 *
 * @typedef {Object} Cta
 * @namespace
 *
 * @memberof Common.Model.Entity.DisplayItem
 *
 * @property {String} ctaHeadline Headline text for the call-to-action element associated with the item.
 * @property {String} ctaByline Byline text for the call-to-action element associated with the item.
 * @property {String} ctaDescription Description text for the call-to-action element associated with the item.
 * @property {String} ctaPrice Price text for the call-to-action element associated with the item.
 * @property {String} ctaButtonText Button text for the call-to-action element associated with the item.
 * @property {String} ctaLink External link for the call-to-action element associated with the item.
 * @property {String} ctaFeatureAssetRef Large/main asset ref for the call-to-action element associated with the item.
 * @property {String} ctaThumbnailAssetRef Small/thumbnail asset ref for the call-to-action element associated with the item.
 */
class Cta {

	constructor(ctaHeadline, ctaByline, ctaDescription, ctaPrice, ctaButtonText, ctaLink, ctaFeatureAssetRef, ctaThumbnailAssetRef) {

		this.ctaHeadline			= ctaHeadline;
		this.ctaByline				= ctaByline;
		this.ctaDescription			= ctaDescription;
		this.ctaPrice				= ctaPrice;
		this.ctaButtonText			= ctaButtonText;
		this.ctaLink				= ctaLink;
		this.ctaFeatureAssetRef		= ctaFeatureAssetRef;
		this.ctaThumbnailAssetRef	= ctaThumbnailAssetRef;
	}
}

export default Cta;